import { render } from "./RidSddAllianz.vue?vue&type=template&id=ffdc8ed4&scoped=true"
import script from "./RidSddAllianz.vue?vue&type=script&lang=js"
export * from "./RidSddAllianz.vue?vue&type=script&lang=js"

import "./RidSddAllianz.vue?vue&type=style&index=0&id=ffdc8ed4&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffdc8ed4"]])

export default __exports__